import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { blogPosts } from '../../data/content';

const resolveAssetUrl = (src) => {
  if (!src) return '';
  if (src.startsWith('http://') || src.startsWith('https://')) return src;
  const publicUrl = process.env.PUBLIC_URL || '';
  return `${publicUrl}${src.startsWith('/') ? src : `/${src}`}`;
};

const formatDate = (value) => {
  if (!value) return '';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value);
  return date.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

const BlogLatestPosts = () => {
  const latest = useMemo(() => {
    return [...blogPosts]
      .sort((a, b) => new Date(b.publishDate || b.updatedDate || 0) - new Date(a.publishDate || a.updatedDate || 0))
      .slice(0, 3);
  }, []);

  return (
    <div className="sidebar__single sidebar__post wow animated fadeInUp" data-wow-delay="0.3s">
      <div className="title">
        <h2>Latest</h2>
      </div>

      <ul className="sidebar__post-list list-unstyled">
        {latest.map((post) => (
          <li key={post.slug}>
            <div className="sidebar__post-image">
              <img
                src={resolveAssetUrl(post.images?.thumbnail || post.images?.hero || '/assets/images/blog/lp-1-1.jpg')}
                alt={post.title}
                onError={(e) => {
                  e.currentTarget.src = resolveAssetUrl('/assets/images/blog/lp-1-1.jpg');
                }}
              />
            </div>
            <div className="sidebar__post-content">
              <h3>
                <Link to={`/events/${post.slug}`}>{post.title}</Link>
              </h3>
              <span className="sidebar__post-content-meta">
                <i className="icon-clock"></i>
                {formatDate(post.publishDate || post.updatedDate)}
              </span>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};

export default BlogLatestPosts;
